export default __webpack_public_path__ + "static/630-2ee2d9018ae0a8621ebc6e83b666fb7b.gif";